import { CSSProperties } from 'react'
import { useTheme } from 'hooks'
import { Spinner } from 'react-bootstrap'

type LoaderProps = {
  message?: string
  fullscreen?: boolean
}

const Loader = ({ message, fullscreen = true }: LoaderProps) => {
  const { theme } = useTheme()

  const containerStyle: CSSProperties = {
    position: fullscreen ? 'fixed' : 'absolute',
    top: 0,
    left: 0,
    width: fullscreen ? '100vw' : '100%',
    height: fullscreen ? '100vh' : '100%',
    backgroundColor: fullscreen ? 'rgba(0, 0, 0, 0.1)' : 'transparent',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999
  }

  return (
    <div style={containerStyle}>
      <div className="d-flex flex-column align-items-center">
        <Spinner animation="border" role="status" className={`text-${theme === 'dark' ? 'white' : 'dark'}`}>
          <span className="visually-hidden">Loading...</span>
        </Spinner>
        {message && <p className={`mt-3 text-center text-${theme === 'dark' ? 'white' : 'dark'}`}>{message}</p>}
      </div>
    </div>
  )
}

export default Loader
